import { INotesState } from 'types/notes'

export const notesSelector = ({ notes }: { notes: INotesState }) => notes
